// libraries
import React from 'react'

// css
import './ReportEditorContentPane.scss'

// dependencies
import Template from './template/index.jsx'
import { Button, Icon } from '@st-operations/uikit/src/v2/index.js'

// component
class ReportEditorContentPane extends React.Component {
  constructor(props) {
    super(props)
    this.pane = React.createRef()
    this.scroll_history = []
    this.scrolling = false
    this.slides = {}
  }

  componentDidMount() {
    this.goToSlide()
    this.pane.current.addEventListener('mousewheel', this.onWheelScroll, {
      passive: false,
    })
  }

  componentDidUpdate() {
    setTimeout(this.goToSlide, 0)
  }

  componentWillUnmount() {
    this.pane.current.removeEventListener('mousewheel', this.onWheelScroll, {
      passive: false,
    })
  }

  // move many slides, then lock to a slide after scrolling stops
  // find the closest slide above where we ended
  onWheelScroll = () => {
    if (this.scroll_timeout) {
      clearTimeout(this.scroll_timeout)
    }
    this.scroll_timeout = setTimeout(() => {
      let location = this.pane.current.scrollTop
      let num_slides = this.props.slides.length
      let height = this.slides[0].offsetHeight
      let i = 0
      while (i < num_slides - 1 && this.slides[i + 1].offsetTop - height / 2 < location) {
        i += 1
      }
      this.props.onChangeSlide(i)
    }, 150)
  }

  goToSlide = (index) => {
    index = index || this.props.index

    // wait for slide refs, then go to slide
    if (Object.keys(this.slides).length == 0) {
      setTimeout(() => {
        this.goToSlide()
      }, 100)
      return
    }

    if (this.scrolling == true) {
      return
    }

    // set scrolling to true
    this.scrolling = true

    // move to slide
    let end = this.slides[index].offsetTop
    let start = this.pane.current.scrollTop
    let now = Date.now()
    let diff = end - start
    let duration = 250
    let interval = setInterval(() => {
      let progress = Math.min(1, (Date.now() - now) / duration)
      if (this.pane.current) {
        this.pane.current.scrollTop = Math.floor(start + progress * diff)
      }
      if (progress >= 1) {
        clearInterval(interval)
        this.scrolling = false
      }
    }, 10)
  }

  renderHeader = () => {
    const { index, onDeleteSlide, onDuplicateSlide, slides } = this.props
    return (
      <div className="slide-header">
        <div className="slide-header__number">
          Slide {index + 1} / {slides.length}
        </div>
        <If condition={slides.length > 1}>
          <span className="slide-header__divider"></span>
          <div className="slide-header__actions">
            <Button className="slide-header__action" onClick={() => onDeleteSlide(index)}>
              <Icon icon="trashcan" type="outline" color="#13682B" height="24px" width="24px" />
              <span>Delete</span>
            </Button>
            <Button className="slide-header__action" onClick={onDuplicateSlide}>
              <Icon icon="uncheckall" type="outline" color="#13682B" height="24px" width="24px" />
              <span>Duplicate</span>
            </Button>
          </div>
        </If>
      </div>
    )
  }

  render() {
    const { slides, audience } = this.props

    return (
      <div
        className="content-pane mac-scrollbar"
        style={{ '--mac-scrollbar-bk': '#f4f4f4' }}
        ref={this.pane}
      >
        <If condition={slides}>
          <For each="slide" index="index" of={slides}>
            <div
              className="slide-slot"
              index={index}
              key={slide.uid}
              ref={(ref) => {
                this.slides[index] = ref
              }}
            >
              <Template
                index={index}
                audience={audience}
                slide={slide}
                Header={this.renderHeader}
              />
            </div>
          </For>
        </If>
      </div>
    )
  }
}

// export
export default ReportEditorContentPane
